module.exports = __webpack_public_path__ + "media/img/feature-icon-filter-c19c01a270153533bdc0db2c45c74670.svg";